import classnames from 'classnames/bind'
import React from 'react'

import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface EditoCenteredTextProps {
  className?: string
  title?: RichTextBlock[]
  text?: RichTextBlock[]
}

function EditoCenteredText({ className, title, text }: EditoCenteredTextProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({
    textPreset: 'title-section-page',
  })
  const textStyle = useStyle({
    textPreset: 'text-paragraph',
    color: 'cornflower-blue',
  })

  return (
    <div className={cx(css.EditoCenteredText, className)}>
      <div className={css.content}>
        <div className={cx(css.grid, gridStyle)}>
          {title && title?.length > 0 && (
            <RichText className={cx(css.title, titleStyle)} render={title} />
          )}
          {text && (
            <RichText className={cx(css.text, textStyle)} render={text} />
          )}
        </div>
      </div>
    </div>
  )
}

EditoCenteredText.defaultProps = {}

export default EditoCenteredText
